import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// In your main.js or a separate firebase.js file
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'



const firebaseConfig = {

    apiKey: "AIzaSyB94FHF6ZXMxEwjiRyf-OyKFDdDPqzN-0M",
  
    authDomain: "ada1-1e7f1.firebaseapp.com",
  
    projectId: "ada1-1e7f1",
  
    storageBucket: "ada1-1e7f1.appspot.com",
  
    messagingSenderId: "284203841384",
  
    appId: "1:284203841384:web:069c86d68a1cbc40dec8dd",
  
    measurementId: "G-45E35FH230"
  
  };
  

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const auth = getAuth(app)

export { db, auth };

createApp(App).use(router).mount("#app");


